/**
 * Configuration des types d'annonces officielles pour l'arbitre
 * Basé sur les règles WSF (World Squash Federation) Singles Rules 2025
 */

export type AnnouncementType =
  | 'match_start'
  | 'score_update'
  | 'handout'
  | 'game_ball'
  | 'match_ball'
  | 'game_end'
  | 'game_start'
  | 'ten_all'
  | 'match_end'
  | 'timer_halftime'
  | 'timer_fifteen_seconds'
  | 'timer_time';

export interface AnnouncementConfig {
  type: AnnouncementType;
  priority: number; // Plus le nombre est élevé, plus l'annonce est prioritaire
  sound?: boolean;
  vibrate?: boolean;
}

/**
 * Configuration par type d'annonce
 * Permet de définir le comportement (son, vibration) et la priorité
 */
export const ANNOUNCEMENT_CONFIGS: Record<AnnouncementType, AnnouncementConfig> = {
  match_start: { type: 'match_start', priority: 10 },
  score_update: { type: 'score_update', priority: 1 },
  handout: { type: 'handout', priority: 2 },
  game_ball: { type: 'game_ball', priority: 5 },
  match_ball: { type: 'match_ball', priority: 6 },
  game_end: { type: 'game_end', priority: 8 },
  game_start: { type: 'game_start', priority: 7 },
  ten_all: { type: 'ten_all', priority: 4 },
  match_end: { type: 'match_end', priority: 10 },
  timer_halftime: { type: 'timer_halftime', priority: 3 },
  timer_fifteen_seconds: { type: 'timer_fifteen_seconds', priority: 3 },
  timer_time: { type: 'timer_time', priority: 3 },
};

/**
 * Durée d'affichage automatique par type d'annonce (en secondes)
 * Après cette durée, l'annonce disparaît automatiquement
 * L'utilisateur peut toujours cliquer pour fermer avant
 */
export const ANNOUNCEMENT_DURATIONS: Record<AnnouncementType, number> = {
  match_start: 10,
  score_update: 3,
  handout: 3,
  game_ball: 5,
  match_ball: 5,
  game_end: 8,
  game_start: 5,
  ten_all: 5,
  match_end: 5,
  timer_halftime: 3,
  timer_fifteen_seconds: 3,
  timer_time: 3,
};

/**
 * Structure d'une annonce à afficher
 */
export interface Announcement {
  type: AnnouncementType;
  lines: string[]; // Tableau de lignes (max 3)
  timestamp: number;
}
